document.querySelectorAll('.Plugin--MultiEventsform').forEach((element) => {
  element
    .querySelector('#htwCrmForm-crm_element_0')
    .addEventListener('change', (e) => {
      element.querySelector(
        '[name="tx_htwevents_multieventsform[event]"]'
      ).value = e.target.value;
    });
});
